import styled from 'styled-components'

import Nav from './Nav'

const BottomNav = ({  }) => {
  return (
    <S_BottomNav>
      <Nav />
    </S_BottomNav>
  )
}

export default BottomNav

const S_BottomNav = styled.div`
  width: 100%;
  height: var(--Header_Height);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
  background: var(--Background);
  box-shadow: var(--Neuo);
  @media only screen and (min-width: 700px) {
    display: none;
  }
`
